<script>
    import Button from 'views/components/button/Button.svelte';
    import Chooser from 'views/components/chooser/Chooser.svelte'
    import Modal from 'views/components/modals/Modal.svelte'

    let {
        title,
        hasCloseButton = true,
        isOpen = $bindable(true),
        chooserOptions,
        submitButtonOptions = null
    } = $props();

    let chooser = $state()
    let submitButton = $state()

    export function getSelection() {
        return chooser.getSelection()
    }

    export function close() {
        isOpen = false
    }

    async function onSubmit() {
        submitButton.disable(true)
        await submitButtonOptions.callback()
        submitButton?.enable()
    }
</script>

<Modal
    {title}
    {hasCloseButton}
    bind:isOpen
    hasMargin={false}>

    <Chooser {...chooserOptions} bind:this={chooser}></Chooser>

    {#snippet buttons()}

        {#if submitButtonOptions}
            <Button label={window.i18n.gettext('Cancel')} theme="secondary" callback={close}></Button>
            <Button bind:this={submitButton} {...submitButtonOptions} callback={onSubmit}></Button>
        {/if}

    {/snippet}
</Modal>
